import * as React from "react"
import type { SVGProps } from "react"
const SvgHeading4 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M3.5 17.86a1 1 0 0 1-.71-.29 1 1 0 0 1-.29-.71v-8q0-.43.29-.72a1 1 0 0 1 .71-.28q.42 0 .71.28.3.3.29.72v3h4v-3q0-.43.29-.72a1 1 0 0 1 .71-.28q.42 0 .71.28.3.3.29.72v8q0 .42-.29.71a1 1 0 0 1-.71.29 1 1 0 0 1-.71-.29 1 1 0 0 1-.29-.71v-3h-4v3q0 .42-.29.71a1 1 0 0 1-.71.29m15 0a1 1 0 0 1-.71-.29 1 1 0 0 1-.29-.71v-2h-4a1 1 0 0 1-.71-.29 1 1 0 0 1-.29-.71v-5q0-.43.29-.72a1 1 0 0 1 .71-.28q.42 0 .71.28.3.3.29.72v4h3v-4q0-.43.29-.72a1 1 0 0 1 .71-.28q.42 0 .71.28.3.3.29.72v4h1q.42 0 .71.28.3.3.29.72 0 .42-.29.71a1 1 0 0 1-.71.29h-1v2q0 .42-.29.71a1 1 0 0 1-.71.29" />
  </svg>
)
export default SvgHeading4
